import { VerifiedOutlined } from '@mui/icons-material';
import { Alert } from '@side/pantry';

// Renders attached beneath a card: the card's bottom border is the
// separator, so the banner drops its own top border.
export function BothSideAgentsBanner() {
  return (
    <Alert
      severity="secondary"
      icon={
        <VerifiedOutlined fontSize="inherit" sx={{ color: 'secondary.dark' }} />
      }
      square
      sx={{
        borderTop: 'none',
        borderBottomLeftRadius: '2px',
        borderBottomRightRadius: '2px',
      }}
    >
      Both agents are Side App users
    </Alert>
  );
}
